import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { WATER_LAKE_TSS } from '../config/services'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
import MarkerLayer from './MarkerLayer'

const id = 'WaterLakeTss'

class WaterLakeTss extends Component {
  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions } = this.props
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const { idToken, layerRendered, paint, time } = this.props
    const visible = layerRendered
    const timeIso = time ? new Date(time).toISOString() : ''
    const rasterSource = {
      type: 'raster',
      tiles: [WATER_LAKE_TSS({ idToken, timeIso })],
      tileSize: 512
    }

    if (!visible) {
      return null
    }

    return [
      <Source
        key={'WaterLakeTssSource'}
        id='WaterLakeTssSource'
        tileJsonSource={rasterSource}
      />,
      <Layer
        key={'WaterLakeTss'}
        type='raster'
        id='WaterLakeTss'
        sourceId='WaterLakeTssSource'
        paint={paint}
        />,
      <MarkerLayer id={id} key={'MarkerLayer'} />
    ]
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(state, 'WaterLakeTss'),
      paint: getPaint(state, 'WaterLakeTss'),
      time: state.layer.times.WaterLakeTss || undefined
    }
  }
  return mapStateToProps
}

export default connect(makeMapStateToProps, null)(WaterLakeTss)



// WEBPACK FOOTER //
// ./src/layers/WaterLakeTss.js